// @flow

import type { Theme } from '../../types/theme';
import defaultTheme from '../default';
import fonts from './mediamarkt.fonts';

export {
  fonts,
};

export const BRAND_PRIMARY = '#00457d';
export const BRAND_SECONDARY = '#ea212d';
export const BRAND_TERTIARY = '#3899df';

export const BRAND_PRIMARY_FROM = '#00457d';
export const BRAND_PRIMARY_TO = '#00457d';

export const BRAND_QUADRUPPLE = '#fa6800';
export const BRAND_CINQAIRE = '#ffa22f';

export const BRAND_PRIMARY_DARK = '#002e54';
export const BRAND_SECONDARY_DARK = '#cf1d29';
export const BRAND_TERTIARY_DARK = '#0e71a8';
export const BRAND_QUADRUPPLE_DARK = '#fa6800';
export const BRAND_CINQAIRE_DARK = '#e38f29';

export const LIGHT_ORANGE = '#ffcaa4';
export const RED = '#ff0007';
export const GREEN = '#51ab36';
export const LIGHT_GREEN = '#abef96';

export const WHITE = '#ffffff';
export const SILVER_LIGHT = '#f3f6f9';
export const SILVER = '#d4d8df';
export const GRAY_LIGHT = '#c2c5cb';
export const GRAY_DARK = '#737c8d';
export const BLACK = '#232323';

export const LIGHT_BLUE = '#cfe8f6';
export const CLOUDY_BLUE = '#bcd2db';

export const FONT_DEFAULT = '"Open Sans", Arial, sans-serif';
export const FONT_HEADING = '"MM-Text", Arial, sans-serif';
export const FONT_ACCENT = '"MM-Headline", Arial, sans-serif';

export const FONT_WEIGHT_DEFAULT = 400;
export const FONT_WEIGHT_HEADING = 600;
export const FONT_WEIGHT_ACCENT = 400;

export const FONT_SIZE_DEFAULT = '1rem';
export const FONT_SIZE_TINY = '0.75rem';
export const FONT_SIZE_SMALL = '0.875rem';
export const FONT_SIZE_H1 = '2.5rem';
export const FONT_SIZE_H2 = '2.125rem';
export const FONT_SIZE_H3 = '1.75rem';
export const FONT_SIZE_H4 = '1.5rem';
export const FONT_SIZE_H5 = '1.125rem';
export const FONT_SIZE_H6 = '1rem';

export const BOX_SHADOW = '0 0 7px 0 rgba(0, 0, 0, 0.3)';
export const DROP_SHADOW = '0 0 7px rgba(0, 0, 0, 0.3)';
export const BORDER_RADIUS_DEFAULT = '6px';
export const BORDER_RADIUS_SMALL = '4px';
export const BORDER_COLOR = SILVER;

export const TEXT_DEFAULT = BLACK;
export const TEXT_SECONDARY = GRAY_DARK;
export const TEXT_TERTIARY = SILVER;
export const TEXT_HERO = WHITE;
export const TEXT_LIGHT = WHITE;
export const HEADING_DEFAULT = BLACK;
export const BACKGROUND_DEFAULT = WHITE;
export const BACKGROUND_LIGHT = SILVER_LIGHT;
export const BACKGROUND_DARK = BLACK;
export const BACKGROUND_ERROR = BLACK;
export const BACKGROUND_SUCCESS = LIGHT_GREEN;

export const PRIMARY_BTN_SCHEME = {
  main: BRAND_PRIMARY,
  hover: BRAND_PRIMARY_DARK,
  active: BRAND_PRIMARY_DARK,
  contrast: WHITE,
  visited: BRAND_PRIMARY,
};

export const PRIMARY_GRADIENT_SCHEME = {
  main: `linear-gradient( to right, ${BRAND_PRIMARY_FROM} , ${BRAND_PRIMARY_TO});`,
  hover: `linear-gradient( to right, ${BRAND_PRIMARY} , ${BRAND_PRIMARY});`,
  active: `linear-gradient( to right, ${BRAND_PRIMARY} , ${BRAND_PRIMARY});`,
  visited: `linear-gradient( to right, ${BRAND_PRIMARY} , ${BRAND_PRIMARY});`,
  contrast: WHITE,
};

export const SECONDARY_BTN_SCHEME = {
  main: BRAND_CINQAIRE,
  hover: BRAND_CINQAIRE_DARK,
  active: BRAND_CINQAIRE_DARK,
  contrast: BLACK,
  visited: BRAND_CINQAIRE,
};

export const TERTIARY_BTN_SCHEME = SECONDARY_BTN_SCHEME;

export const LIGHT_BTN_SCHEME = {
  main: WHITE,
  hover: SILVER_LIGHT,
  active: SILVER_LIGHT,
  contrast: WHITE,
  visited: WHITE,
};

export const MAIN_MENU_SCHEME = {
  main: BRAND_PRIMARY,
  hover: BRAND_SECONDARY,
  active: BRAND_SECONDARY,
  contrast: BRAND_TERTIARY,
  visited: BRAND_PRIMARY,
};
export const SUB_MENU_SCHEME = {
  main: WHITE,
  hover: WHITE,
  active: WHITE,
  contrast: BRAND_TERTIARY,
  visited: WHITE,
};

export const DISABLED_BTN_SCHEME = {
  main: GRAY_LIGHT,
  hover: GRAY_LIGHT,
  active: GRAY_LIGHT,
  contrast: WHITE,
  visited: GRAY_LIGHT,
};

/*
 * COLOR SCHEMES
 */
export const DEFAULT_SCHEME = {
  background: 'transparent',
  border: SILVER_LIGHT,
  text: TEXT_DEFAULT,
  heading: HEADING_DEFAULT,
  anchor: BRAND_SECONDARY,
  shadow: BOX_SHADOW,
};

export const DEFAULT_LIGHT_SCHEME = {
  background: 'transparent',
  border: SILVER_LIGHT,
  text: WHITE,
  heading: WHITE,
  icons: WHITE,
  anchor: WHITE,
  shadow: BOX_SHADOW,
};

export const LIGHT_SCHEME = {
  background: SILVER_LIGHT,
  border: SILVER,
  text: TEXT_DEFAULT,
  heading: HEADING_DEFAULT,
  anchor: BRAND_SECONDARY,
  shadow: BOX_SHADOW,
};

export const WHITE_SCHEME = {
  background: WHITE,
  border: SILVER_LIGHT,
  text: TEXT_DEFAULT,
  heading: HEADING_DEFAULT,
  anchor: BRAND_SECONDARY,
  shadow: BOX_SHADOW,
};

export const DARK_SCHEME = {
  background: BLACK,
  border: SILVER_LIGHT,
  text: WHITE,
  heading: WHITE,
  icons: WHITE,
  anchor: WHITE,
  shadow: BOX_SHADOW,
};

export const PRIMARY_SCHEME = {
  background: BRAND_PRIMARY,
  border: SILVER_LIGHT,
  text: WHITE,
  heading: WHITE,
  icons: WHITE,
  anchor: WHITE,
  shadow: BOX_SHADOW,
};

export const SECONDARY_SCHEME = {
  background: BRAND_SECONDARY,
  border: SILVER_LIGHT,
  text: WHITE,
  heading: WHITE,
  icons: WHITE,
  anchor: WHITE,
  shadow: BOX_SHADOW,
};

export const TERTIARY_SCHEME = {
  background: BRAND_TERTIARY,
  border: SILVER_LIGHT,
  text: WHITE,
  heading: WHITE,
  icons: WHITE,
  anchor: WHITE,
  shadow: BOX_SHADOW,
};
const defaults = [{
  BRAND_PRIMARY,
  BRAND_SECONDARY,
  BRAND_SECONDARY_DARK,
  BRAND_TERTIARY,
  BRAND_PRIMARY_FROM,
  BRAND_PRIMARY_TO,
  WHITE,
  SILVER,
  GRAY: GRAY_LIGHT,
  GRAY_DARK,
  BLACK,
  ERROR: RED,
  SUCCESS: GREEN,
  FONT_DEFAULT,
  FONT_HEADING,
  FONT_ACCENT,
  FONT_WEIGHT_DEFAULT,
  FONT_WEIGHT_HEADING,
  FONT_WEIGHT_ACCENT,
  TEXT_DEFAULT,
  TEXT_SECONDARY,
  TEXT_TERTIARY,
  TEXT_HERO,
  TEXT_LIGHT,
  HEADING_DEFAULT,
  BACKGROUND_DEFAULT,
  BACKGROUND_LIGHT,
  BACKGROUND_DARK,
  BACKGROUND_ERROR,
  BACKGROUND_SUCCESS,
  FONT_SIZE_H1,
  FONT_SIZE_H2,
  FONT_SIZE_H3,
  FONT_SIZE_H4,
  FONT_SIZE_H5,
  FONT_SIZE_H6,
  FONT_SIZE_DEFAULT,
  FONT_SIZE_SMALL,
  FONT_SIZE_TINY,
  BOX_SHADOW,
  DROP_SHADOW,
  BORDER_RADIUS_DEFAULT,
  BORDER_RADIUS_SMALL,
  BORDER_COLOR,
  PRIMARY_BTN_SCHEME,
  PRIMARY_GRADIENT_SCHEME,
  SECONDARY_BTN_SCHEME,
  TERTIARY_BTN_SCHEME,
  LIGHT_BTN_SCHEME,
  MAIN_MENU_SCHEME,
  DISABLED_BTN_SCHEME,
  DEFAULT_SCHEME,
  DEFAULT_LIGHT_SCHEME,
  WHITE_SCHEME,
  LIGHT_SCHEME,
  DARK_SCHEME,
  PRIMARY_SCHEME,
  SECONDARY_SCHEME,
  TERTIARY_SCHEME,
}];

const mediamarkt: Theme = defaultTheme(
  defaults,
  {
    buttons: {
      borderRadius: BORDER_RADIUS_DEFAULT,
      fontFamily: FONT_HEADING,
      fontSize: '1.5rem',
      fontWeight: 600,
      scheme: {
        default: SECONDARY_BTN_SCHEME,
        secondary: SECONDARY_BTN_SCHEME,
      },

    },
    carblock: {
      title: {
        color: BRAND_PRIMARY,
      },
      deliveryTime: {
        color: BRAND_PRIMARY,
      },
      fromPrice: {
        color: BRAND_QUADRUPPLE,
      },
    },
    gallery: {
      descriptionColor: BLACK,
      boxedDescriptionColor: WHITE,
      image: {
        selectedColor: BLACK,
      },
    },
    list: {
      title: {
        color: BRAND_PRIMARY,
        fontFamily: FONT_HEADING,
      },
      listStyles: {
        dot: {
          size: '.375em',
          color: BRAND_QUADRUPPLE,
        },
        numbered: {
          color: BRAND_QUADRUPPLE,
        },
      },
    },
    pdbCTA: {
      deliverytimeColor: BLACK,
    },
    pdbInfo: {
      availableText: {
        color: TEXT_SECONDARY,
        fontSize: FONT_SIZE_SMALL,
      },
      borderColor: WHITE,
      basicPriceLabel: {
        color: TEXT_DEFAULT,
        fontSize: FONT_SIZE_H5,
      },
      mileageAndDuration: {
        color: WHITE,
        fontSize: {
          default: FONT_SIZE_TINY,
          lg: FONT_SIZE_SMALL,
        },
      },
      motorSpecs: {
        color: WHITE,
        fontFamily: FONT_HEADING,
        fontSize: FONT_SIZE_H5,
      },
      fromPrice: {
        color: WHITE,
        fontSize: FONT_SIZE_SMALL,
      },
      fromPriceText: {
        color: WHITE,
        fontSize: FONT_SIZE_SMALL,
      },
      occasionText: {
        color: '#fff029',
        fontSize: FONT_SIZE_SMALL,
      },
      price: {
        color: '#fff029',
        fontSize: FONT_SIZE_H3,
        fontFamily: FONT_HEADING,
      },
      title: {
        color: WHITE,
        fontFamily: FONT_HEADING,
        fontSize: {
          default: FONT_SIZE_H4,
          md: FONT_SIZE_H3,
          lg: FONT_SIZE_H2,
        },
      },
    },
    review: {
      starColor: BRAND_QUADRUPPLE,
    },
    tooltip: {
      iconColor: GRAY_LIGHT,
    },
    wysiwyg: {
      primary: BRAND_PRIMARY,
      templates: {
        default: {
          h1: {
            fontFamily: FONT_HEADING,
          },
          h2: {
            fontFamily: FONT_HEADING,
          },
          h3: {
            fontFamily: FONT_HEADING,
          },
          h4: {
            fontFamily: FONT_HEADING,
          },
          h5: {
            fontFamily: FONT_HEADING,
            fontSize: {
              default: FONT_SIZE_H2,
            },
          },
          h6: {
            color: GRAY_DARK,
            fontFamily: FONT_HEADING,
            fontSize: {
              default: FONT_SIZE_H4,
            },
          },
          subheadingMargin: '1rem',
          subheadingfontWeight: 400,
        },
        hero: {
          h1: {
            fontFamily: FONT_HEADING,
            fontWeight: FONT_WEIGHT_HEADING,
            fontSize: {
              default: '2.5rem',
            },
            lineHeight: '1',
          },
          h2: {
            fontFamily: FONT_HEADING,
          },
          h3: {
            fontFamily: FONT_HEADING,
          },
          h4: {
            fontFamily: FONT_ACCENT,
            fontSize: {
              default: '2rem',
            },
            lineHeight: '1',
          },
          h5: {
            fontFamily: FONT_HEADING,
            fontSize: FONT_SIZE_H2,
          },
        },
        banner: {
          h1: {
            color: '#fff029',
            fontFamily: FONT_HEADING,
            fontWeight: FONT_WEIGHT_HEADING,
            fontSize: {
              default: '2.125rem',
            },
            lineHeight: '1',
          },
        },
      },
    },
  },
);


export default mediamarkt;
